import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import ToggleButtonListItem from '../../../../../../list-items/ToggleButtonListItem';
import { MOVEMENT_DIRECTION } from '../../../../Preview/PreviewDisplayConstants';

const directionOptions = [
    { value: MOVEMENT_DIRECTION.INWARD, text: 'Inward' },
    { value: MOVEMENT_DIRECTION.OUTWARD, text: 'Outward' },
];

const WaveLayerInwardsListItem = memo(({ index, movementDirection, updateWaveLayerCustomOptions }) => {
    const handleChange = useCallback(
        (value) => updateWaveLayerCustomOptions(index, "movementDirection", value),
        [index]
    );

    return (
        <ToggleButtonListItem
            text="Direction"
            value={movementDirection || MOVEMENT_DIRECTION.OUTWARD}
            onChange={handleChange}
            options={directionOptions}
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { movementDirection } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    return { movementDirection };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerInwardsListItem);
